import {
  IBackendCartEntries,
  ICartEntry,
  IItem,
  IItemOptionModifier,
  IMainMenuViewOption,
  IWithPricingProps,
} from '@rbi-ctg/menu';
import { DAY_PART_SELECTIONS } from 'state/menu/main-menu/types';
import { CartEntryType } from 'utils/cart';

export interface IComputeItemOptionModifierPlu extends IWithPricingProps {
  item: IBackendCartEntries | ICartEntry | IItem;
  modifier: IBackendCartEntries | ICartEntry | (IItemOptionModifier & { quantity?: number });
}

export type CartEntryObject = {
  children?: CartEntryObject[];
  price?: number;
  quantity?: number;
  type: CartEntryType;
};

export interface IGetTabbedMenuData {
  mainMenuItems: IMainMenuViewOption[];
  dayPartMenu?: DAY_PART_SELECTIONS | null;
}
